module.exports = __webpack_public_path__ + "static/kran01_512-84f05f9781476280793849cfd0dec686.jpg";